import * as React from 'react';

import {Button} from 'shells/button/button';
import {getSalesDocumentStatusText} from 'shells/lead-sidebar/sales-documents/helpers';
import {Modal} from 'shells/modal/modal';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';

export type ConfirmationVariant = 'paid' | 'void';

type Props = {
    variant: ConfirmationVariant;
    onSubmit: (comment: string, status: QuoteDisplayStatus) => void;
    onClose: () => void;
    currentStatus: QuoteDisplayStatus;
};

export function StatusConfirmationModal(props: Props) {
    const [comments, setComments] = React.useState<string>('');

    const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();

        props.onSubmit(comments, props.variant === 'paid' ? 'ACCEPTED' : 'REVOKED');
        props.onClose();
    };

    const handleCommentsChange = React.useCallback((newComments: string) => {
        setComments(newComments);
    }, []);

    const headerText = props.variant === 'paid' ? 'Mark as paid' : 'Void invoice';
    const actionText = props.variant === 'paid' ? 'paid' : 'void';
    const currentStatusText = getSalesDocumentStatusText(
        props.currentStatus,
        'Invoice'
    ).toLowerCase();

    return (
        <Modal
            headerText={headerText}
            closeButton={true}
            isOpen={true}
            onClose={props.onClose}
            maxWidth={500}
            maxHeight={380}
            isCentered={true}
        >
            <form className='flex flex-dir-col justify-sb full-height' onSubmit={handleSubmit}>
                <div>
                    <Body size='normal'>
                        Are you sure you want to mark this invoice as {actionText}? You can add an
                        optional comment before confirming.
                    </Body>
                    <div className='flex flex-dir-col mt-32'>
                        <Body color='light' size='small'>
                            Comments (optional)
                        </Body>
                        <div className='mt-8'>
                            <TextField
                                value={comments}
                                placeholder='Add additional information or evidence'
                                onChange={handleCommentsChange}
                                id='comments'
                                focusOnMount={true}
                                minHeight={100}
                                multiline={true}
                            />
                        </div>
                    </div>
                </div>
                <div className='my-32 flex justify-sb'>
                    <Button variant='text-secondary' onClick={props.onClose}>
                        Keep as {currentStatusText}
                    </Button>
                    <Button
                        type='submit'
                        size='big'
                        variant={props.variant === 'paid' ? 'save' : 'danger'}
                    >
                        Mark as {actionText}
                    </Button>
                </div>
            </form>
        </Modal>
    );
}
